import { defineStore } from 'pinia'
import { fetchPageMeta } from '@/api/geogrids/live'

const STATE = () => ({
  pointDistances: {},
  distanceMeasures: {},
  gridSizes: [],
  algorithms: {},
  periodicityOptions: {},
  dayNumberOptions: [],
  weekNumberOptions: [],
  timeZones: [],
  restoreGeogridFormState: false,
  keywordMetricsEnabled: false
})

export const useGeogridsCommonStore = defineStore('geogridsCommon', {
  state: () => ({ ...STATE(), loaded: false }),
  actions: {
    initialize(data) {
      Object.keys(STATE()).forEach((key) => {
        if (data[key] !== undefined) this[key] = data[key]
      })
      this.loaded = true
    },
    // Router `prepare` hook: no-op when the styxie payload already hydrated
    // the store, fetches once on client-side entry into geogrids.
    async ensurePageMeta() {
      if (this.loaded) return

      const res = await fetchPageMeta()
      this.initialize(res.data)
    }
  }
})
